import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchResultDescWrap } from "@/components/Books/List/BooksResultDesc";
import React from "react";
import { CustomSelect, SearchResultAmount } from "@/components/Categories/Menu";
export const SearchResultDesc = (param)=>{
    let { totalCount , sortList , sort , handleSortFilter  } = param;
    if (totalCount === 0) return null;
    return /*#__PURE__*/ _jsxs(SearchResultDescWrap, {
        children: [
            /*#__PURE__*/ _jsxs(SearchResultAmount, {
                children: [
                    "검색결과 ",
                    totalCount,
                    "건"
                ]
            }),
            /*#__PURE__*/ _jsx(CustomSelect.CustomTextField, {
                select: true,
                value: sort,
                onChange: (e)=>{
                    handleSortFilter(e.target.value);
                },
                children: sortList.map((option)=>{
                    return /*#__PURE__*/ _jsx(CustomSelect.CustomSelectMenuItem, {
                        value: option.value,
                        className: "select",
                        children: option.label
                    }, option.value);
                })
            })
        ]
    });
};
